import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "swiper-in-swiper-title PingFangSC-Medium font-21" }
const _hoisted_2 = { class: "swiper-in-swiper-scrollview_inner" }

import { ProductCategoryConfig } from '@/data/const'
import { FORMATTED_PRODUCT_SERIE } from '@/data/series'
import useScreen from '@/hooks/use-screen'
import { isAndroid, isIOS } from '@/utils/device'
import { computed, ref, watch } from 'vue'

// eslint-disable-next-line no-undef
const designedSpaceAHeight = 32
const designedTitleHeight = 27
const designedSlideWidth = 309
const designedSlideHeight = 500

export default /*@__PURE__*/_defineComponent({
  __name: 'SwiperInSwiper',
  props: {
  title: {
    type: String,
    required: true
  },
  dataSource: {
    type: Array as () => FORMATTED_PRODUCT_SERIE[] | ProductCategoryConfig[],
    required: true
  },
  initIndex: {
    type: Number,
    default: 1
  }
},
  emits: ['touchscroller'],
  setup(__props, { emit: __emit }) {

const emit = __emit

// eslint-disable-next-line no-undef
const props = __props

const scroller = ref<HTMLDivElement>()

const designedSpaceBHeight = isAndroid ? 60 : 43
const designedContainerHeight =
  designedSpaceAHeight * 2 +
  designedTitleHeight +
  designedSlideHeight +
  designedSpaceBHeight
const container = ref<HTMLDivElement>()
const containerHeight = computed(() => {
  return (
    container.value?.getBoundingClientRect()?.height || designedContainerHeight
  )
})

const { designWidth, screenWidth, rootScale } = useScreen()
const itemSize = computed(() => {
  const minWhiteSpace = designWidth - designedSlideWidth
  const maxSlideWidth = screenWidth.value - minWhiteSpace
  const maxSlideHeight = designedSlideHeight * rootScale.value

  let width = designedSlideWidth
  let height = designedSlideHeight
  let left = minWhiteSpace / 2

  if (containerHeight.value >= designedContainerHeight * rootScale.value) {
    // TODO
    height = maxSlideHeight
    width = designedSlideWidth * rootScale.value
  } else {
    const spaceHeights =
      (designedSpaceAHeight * 2 + designedTitleHeight + designedSpaceBHeight) *
      rootScale.value
    height = containerHeight.value - spaceHeights
    width = (designedSlideWidth * height) / designedSlideHeight
  }

  return {
    width: `${width}px`,
    maxWidth: `${maxSlideWidth}px`,
    height: `${height}px`,
    left: `${left}px`
  }
})

watch(scroller, (el, old) => {
  if (el && !old) {
    const item = el.children[0].children[props.initIndex] as HTMLDivElement
    // console.log(item?.getBoundingClientRect())
    if (item) {
      el.scrollTo({
        left: item.getBoundingClientRect().left,
        behavior: 'instant'
      })
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["swiper-in-swiper", { 'is-ios': _unref(isIOS) }]),
    ref_key: "container",
    ref: container,
    style: _normalizeStyle({
      '--sub-swiper-item-width': itemSize.value.width,
      '--sub-swiper-item-height': itemSize.value.height,
      '--sub-swiper-item-max-width': itemSize.value.maxWidth
    })
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "swiper-in-swiper-space swiper-in-swiper-space-1" }, null, -1)),
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-in-swiper-space swiper-in-swiper-space-2" }, null, -1)),
    _createElementVNode("div", {
      class: "swiper-in-swiper-scrollview",
      ref_key: "scroller",
      ref: scroller,
      onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (emit('touchscroller')))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSource, (data, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "swiper-in-swiper-item"
          }, [
            _renderSlot(_ctx.$slots, "default", {
              data: data as (FORMATTED_PRODUCT_SERIE & ProductCategoryConfig)
            })
          ]))
        }), 128))
      ])
    ], 544),
    _createElementVNode("div", {
      class: _normalizeClass(["swiper-in-swiper-bottom", { 'is-android': _unref(isAndroid) }])
    }, null, 2)
  ], 6))
}
}

})